import { stringify } from '../polyfills';
export function parseLog(jsonLog, logKey, isCompact) {
    var _a;
    if (isCompact === void 0) { isCompact = false; }
    var message = (_a = {}, _a[logKey] = jsonLog, _a);
    return stringify(message, null, isCompact ? 0 : 2);
}
